import { layoutService } from '@/api';
import { tools } from '@/utils/tools';
export default function fieldPermission() {
  /**
   * @brief 验证字段权限合并方法
   * @param fieldKey [string|array]当前字段key或关联对象表格数组集合
   * @param permission object 权限对象
   * @param validatePermission string 当前验证权限[r|w|!] r是否可读 w是否可编辑 !是否必填
   * @param defaultStatus number 字段默认权限 当权限不包含此字段，不进入判断逻辑时使用此字段
   * @return number 字段对应权限
   */
  const validateField = (fieldKey, permission, validatePermission, defaultStatus) => {
    let status = 0;
    let _fieldKey = fieldKey;
    //新建编辑中因为joker和permission合并，关联对象表格会传参数组，分别判断joker和permission 其他为字符串
    if (typeof fieldKey === 'object' && Array.isArray(fieldKey) && fieldKey?.length == 2) {
      _fieldKey = String(permission?.[fieldKey[0]] ? fieldKey[0] : fieldKey[1]);
    }
    if (validatePermission == '!') {
      //打印调试 [r|w|!] r是否可读 w是否可编辑 !是否必填
      // console.log(_fieldKey, fieldKey, _fieldKeys?.includes(_fieldKey), permission?.[_fieldKey], 'console.log')
    }
    if (permission?.[_fieldKey] !== undefined) {
      if (permission[_fieldKey]?.includes(validatePermission)) {
        status = 1;
      }
    } else {
      status = Number(defaultStatus);
    }

    return status;
  };

  /**
   * @brief 字段是否显示
   * @param fieldKey
   * @param permission
   * @param defaultShow
   * @return {*}
   */
  const isShowField = (fieldKey, permission = {}, defaultShow = 1) => {
    return validateField(fieldKey, permission, 'r', defaultShow);
  };

  /**
   * @brief 字段是否必填
   * @param fieldKey
   * @param permission
   * @param defaultRequired
   * @return {*}
   */
  const isRequiredField = (fieldKey, permission = {}, defaultRequired = 0) => {
    return validateField(fieldKey, permission, '!', defaultRequired);
  };

  /**
   * @brief 字段是否可编辑
   * @param fieldKey
   * @param permission
   * @param defaultEditable
   * @return {*}
   */
  const isEditableField = (fieldKey, permission = {}, defaultEditable = 1) => {
    return validateField(fieldKey, permission, 'w', defaultEditable);
  };

  /**
   * @brief 更新字段权限
   * @param tableData 表格整体数据
   * @param entity 对象
   * @param fieldValue 快捷编辑的字段值
   * @param businessId 数据id
   * @param fieldKey 快捷编辑的字段fieldKey
   * @param subFormFieldKey 子表单字段key，如果编辑的是子表单子字段的话
   * @param subId 子表单数据id，如果编辑的是子表单子字段的话
   * @return {tableData<array>}  更新后的表格数据
   */
  const updateFieldPermission = async (tableData, entity, { fieldValue, businessId, fieldKey, subFormFieldKey = undefined, subId = undefined }) => {
    try {
      const dataIndex = tableData?.findIndex((td) => td?.id == businessId);
      if (dataIndex == -1) {
        return false;
      }
      const _tv = tableData[dataIndex];
      //因为行内编辑是临时显示，表格数据不会变，这里更新一下，不然重渲规则会丢失最新的值
      if (subFormFieldKey) {
        //子表单赋值
        const subIndex = _tv[subFormFieldKey]?.findIndex((td) => td?.id == subId);
        _tv[subFormFieldKey][subIndex][fieldKey] = fieldValue;
      } else {
        _tv[fieldKey] = fieldValue;
      }
      const res = await layoutService.fieldPermission({
        type: 'ID',
        value: businessId,
        entity: entity,
        source: 4
      });
      if (!res?.error) {
        _tv['PERMISSION'] = res?.result?.permissions || {};
      }

      // console.log('tableData33', tableData)

      return tableData;
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * @brief 表单设计、布局权限备份
   * @param {Object} formData
   * @param {number|string} type
   * @return {Object} 备份初始化数据
   */
  const initPermissionBak = (formData, type) => {
    const _bak = {};
    formData?.forEach((_item) => {
      _item?.modules?.forEach((_sub) => {
        //兼容部分表格value为null的问题
        if (_sub?.type == 20) {
          //字段备份
          _bak[_sub.value] = {
            isRequired: _sub.isRequired,
            businessData: Number(_sub.businessData),
            display: _sub.display
          };
        } else if (_sub?.type == 30 || _sub?.type == 31 || _sub?.type == 35) {
          //关联对象表格备份
          const _tableBak = {
            isRequired: _sub.isRequired,
            businessData: 1,
            display: _sub.display
          };
          if (_sub?.attributeRead?.length && (((type == 30 || type == 50) && _sub?.attributeRead?.includes('1')) || (type == 40 && _sub?.attributeRead?.includes('2')))) {
            _tableBak.businessData = 0;
          }
          //兼容部分表格value为null的问题 使用id匹配
          _bak[_sub?.value || _sub?.id] = _tableBak;
          if (_sub?.type == 35) {
            const _permissionBak = _sub.permission && tools.isJSON(_sub.permission) ? JSON.parse(_sub.permission) : {};
            _sub?.modules?.forEach((_subItem) => {
              _bak[`${_sub.value}.${_subItem.value}`] = {
                isRequired: _subItem.isRequired,
                businessData: Number(_subItem.businessData) && (type == 30 || type == 50 || (_permissionBak?.canEdit == 1 && _permissionBak?.detail?.edit == 1)) ? 1 : 0,
                display: _subItem.display
              };
            });
          }
        }
      });
    });
    return _bak;
  };

  return {
    isShowField,
    isRequiredField,
    isEditableField,
    updateFieldPermission,
    initPermissionBak
  };
}
